import { useState } from 'react';

import {
  LayoutWithNavigationBreadcrumbs,
  NavigationBreadcrumbsTitles,
} from 'components';
import { FormSubmit } from 'libs/form';
import { Stack } from 'libs/ui';
import { DeepPartial } from 'types/deepPartial';

import {
  OrderFormContent,
  OrderFormFooter,
  type OrderFormFooterProps,
  OrderFormHeader,
  type OrderFormHeaderProps,
} from '../components';
import { OrderForm } from '../components/OrderForm';
import { OrderFormType } from '../forms/orderForm';
import { OrderFormTab } from '../types';

export interface OrderViewProps {
  title: OrderFormHeaderProps['title'];
  breadcrumbsTitles?: NavigationBreadcrumbsTitles;
  initialValues: DeepPartial<OrderFormType>;
  submitLoading: OrderFormFooterProps['submitLoading'];
  onSubmit: FormSubmit<OrderFormType>;
}

export const OrderView = ({
  breadcrumbsTitles,
  initialValues,
  title,
  submitLoading,
  onSubmit,
}: OrderViewProps) => {
  const [tab, setTab] = useState<OrderFormTab>(OrderFormTab.orderDetails);

  return (
    <LayoutWithNavigationBreadcrumbs titles={breadcrumbsTitles}>
      <OrderForm initialValues={initialValues} onSubmit={onSubmit}>
        <Stack spacing={24}>
          <OrderFormHeader tab={tab} title={title} />
          <OrderFormContent tab={tab} onTabChange={setTab} />
          <OrderFormFooter submitLoading={submitLoading} />
        </Stack>
      </OrderForm>
    </LayoutWithNavigationBreadcrumbs>
  );
};
